import axios from './axios'
import { IDailySnapshot } from '../@types/Dashboard/IDailySnapshot'

const getDailySnapshot = (
  farmId: number[], 
  areaIds: number[], 
  startDate: string, 
  endDate: string,
  isByBatch: boolean = false
): Promise<IDailySnapshot[]> => {
  const params = new URLSearchParams();
  farmId.forEach(farm => {
    params.append('farmId', farm.toString());
  });
  areaIds.forEach(areaId => {
    params.append('areaIds', areaId.toString());
  });
  params.append('startDate', startDate);
  params.append('endDate', endDate);
  params.append('isByBatch', isByBatch.toString());

  return axios.get<IDailySnapshot[]>(`/analytics/snapshots/daily-snapshot?${params.toString()}`).then(({ data }) => {
    return data
  })
}

export const analyticsService = {
  getDailySnapshot
}
